import React, { Fragment, useEffect, useContext } from "react";
import TestNavigation from "../../components/TestNavigation";
import { ProfileContext } from "../../reducers/profile";
import { useHistory } from "react-router";

export default ({ children }) => {
  const history = useHistory();
  const { state, dispatch } = useContext(ProfileContext);
  const max = state.finalists;

  useEffect(() => {
    history.push(`/finalists/${state.selected ? state.selected : ""}`);
  }, [state.selected]);

  const _next = () => {
    const selected = !state.selected
      ? 1
      : max === state.selected
      ? null
      : state.selected + 1;

    dispatch({
      type: "ME_RELOAD",
      payload: { selected },
    });
  };

  const _prev = () => {
    const selected = !state.selected
      ? max
      : state.selected === 1
      ? null
      : state.selected - 1;

    dispatch({
      type: "ME_RELOAD",
      payload: { selected },
    });
  };

  return (
    <Fragment>
      <TestNavigation
        _prev={_prev}
        _next={_next}
        dispatch={dispatch}
        selected={state.selected}
        max={max}
      />
      {children}
    </Fragment>
  );
};
